/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { ListItemButton, listItemButtonClasses } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

export interface AppMenuItemProps {
    onClick?: () => void;
    disabled?: boolean;
    icon: JSX.Element;
    text: string;
    href?: string;
}

export default function AppMenuItem(props: AppMenuItemProps) {
    return (
        <ListItem
            onClick={props.onClick}
            disabled={props.disabled}
            disablePadding
            dense
            sx={{
                minHeight: "2.5rem",
                [`& .${listItemButtonClasses.root}.${listItemButtonClasses.dense}`]: {
                    px: 1,
                },
            }}
        >
            <ListItemButton
                {
                    ...(
                        !!props.href ? {
                            component: "a",
                            href: props.href,
                            target: "_blank",
                            rel: "noopener noreferrer"
                        } : {}
                    )
                }
            >
                <ListItemIcon>{props.icon}</ListItemIcon>
                <ListItemText primary={props.text} />
            </ListItemButton>
        </ListItem>
    );
}
